import {
	AudioCoverageAreaType,
	AudioCoverageAreaTypeConstraints,
	FloatRange
} from '@shure/shared/angular/data-access/system-api/core';
import { PositionUnit } from '@shure/shared/angular/utils/utils-position';

import { ConstraintsRange, CoverageAreaConstraints, CoverageAreaConstraintsRange } from '../../api/models';

export class SysApiCoverageAreaConstraintsMapper {
	/** Map `CoverageAreaConstraints` for the type of coverage area */
	public static toCoverageAreaConstraints(
		type?: AudioCoverageAreaType,
		constraints?: AudioCoverageAreaTypeConstraints | undefined | null
	): CoverageAreaConstraints {
		const found = constraints?.options.find((o) => o.type.options === type);
		if (found) {
			return {
				distance: SysApiCoverageAreaConstraintsMapper.toPositionUnitConstraints(found.distance.range),
				height: SysApiCoverageAreaConstraintsMapper.toPositionUnitConstraints(found.height.range),
				width: SysApiCoverageAreaConstraintsMapper.toPositionUnitConstraints(found.width.range)
			};
		}

		return {
			distance: SysApiCoverageAreaConstraintsMapper.toPositionUnitConstraints(),
			height: SysApiCoverageAreaConstraintsMapper.toPositionUnitConstraints(),
			width: SysApiCoverageAreaConstraintsMapper.toPositionUnitConstraints()
		};
	}

	public static toPositionUnitConstraints(range: FloatRange | undefined = undefined): CoverageAreaConstraintsRange {
		return {
			min: PositionUnit.fromRaw(range?.min ?? 0),
			max: PositionUnit.fromRaw(range?.max ?? 0),
			step: PositionUnit.fromRaw(range?.step ?? 0)
		};
	}

	public static toConstraints(range: FloatRange | undefined = undefined): ConstraintsRange {
		return {
			min: range?.min ?? 0,
			max: range?.max ?? 0,
			step: range?.step ?? 0
		};
	}
}
